<div class="main">
  <div [style.flex-grow]="1"></div>

  <ffs-bankid
    mode="login"
    [audience]="environment.audience"
    [bankIdUrl]="environment.bankIdGatewayUrl"
    (accessToken)="service.login($event)"
  ></ffs-bankid>

  <div [style.flex-grow]="1"></div>

</div>
